module.exports = __webpack_public_path__ + "static/media/OurProduct-TanBlockMobile.b3a3f864.svg";